
<template>
  <!-- Cong viec duoc giao -->
  <div id="wrapper" class="page">
    <task-side-bar index="1" />
    <div id="content-wrapper">
      <div class="container-fluid">
        <div>
          <b-row>
            <div class="form-inline" style="width: 100%">
                <b-form-input
                  style="flex-grow: 1"
                  v-model="query"
                  placeholder="Tìm theo tên công việc, người giao, người nhận"
                  @keydown.enter.prevent="queryItem"
                ></b-form-input>
                <button class="btn" @click.prevent="queryItem">
                  <i class="fas fa-search"></i>
                </button>
                <button class="btn" id="popover-target-1">
                  <i class="fas fa-filter"></i>
                </button>
            </div>
            <b-popover target="popover-target-1" triggers="click blur">
              <template v-slot:title>Lọc tình trạng</template>
              <b-form-select
                v-model="taskStatus"
                :options="taskStatuses"
                @change="filterStatus"
              >
                <template v-slot:first>
                  <b-form-select-option value="-1"
                    >Tất cả</b-form-select-option
                  >
                </template>
              </b-form-select>
            </b-popover>

            <!-- Content -->
            <b-table
              id = "my-table"
              bordered
              head-variant="dark"
              hover
              responsive
              small
              striped
              :fields="fields"
              :items="items"
              table-variant="light"
              @sort-changed="sortChanged"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
            >
              <!-- sortDirection="name" -->
              <!-- :sort-compare="myCompare" -->
              <template #cell(STT)="data">
                  {{ data.index + 1 }}
              </template>
              <template v-slot:cell(name)="data">
                <b-link href="#" @click.prevent="viewItem(data)">
                  <div v-if="data.item.important == 1" class= "linkImportant">{{data.value}}</div>
                  <div v-else class="link">{{data.value}}</div>
                </b-link>
              </template>
              <!-- Nguoi giao -->
              <template v-slot:cell(empCreated)="data">
                <i class="fas fa-user-tie mr-2"></i>
                {{ data.value }}
              </template>
              <!-- Nguoi nhan -->
              <!-- <template v-slot:cell(employee)="data">
                <i class="fas fa-user mr-2"></i>
                {{ data.value }}
              </template> -->
              <template v-slot:cell(start)="data">
                {{ formatDate (data.item.start) }}
              </template>
              <template v-slot:cell(end)="data">
                   <!-- Ngay ket thuc cong viec < Ngay hien tai && Cong viec chua hoan thanh -->
                  <span  v-if="data.item.end == null">
                  </span>
                  <span
                    style="background-color:#ffcccc;"
                    v-else-if="new Date(data.item.end) < Date.now() && data.item.status != 2"
                  >
                    {{ data.item.end | moment("DD/MM/YYYY") }}
                  </span>
                  <span v-else> {{ data.item.end | moment("DD/MM/YYYY") }} </span>
              </template>

               <!-- Độ ưu tiên -->
              <!-- <template v-slot:cell(important)="data">
                <i v-if="data.item.important == 1"
                  class="fas fa-flag mr-2 text-danger"
                ></i>
              </template> -->
               <!-- Hàng tháng / Label = 1 -->
              <template #cell(label)="data">
                <!-- <i v-if="data.value == 1"
                  class="fas fa-calendar-alt text-info"
                ></i> -->
                <span v-if="data.value == 1">
                 <img
                      src="../assets/monthly.png"
                      height="20px"
                      width="20px"
                  />
                </span>
              </template>
              <template v-slot:cell(status)="data">
                <b-badge variant="warning" v-if="data.value == 0">
                  <b>Chưa bắt đầu</b>
                </b-badge>
                <b-badge variant="info" v-if="data.value == 1">
                  <b>Đang thực hiện</b>
                </b-badge>
                <!-- Hoàn thành màu xanh lá cây  -->
                <b-badge variant="success" v-if="data.value == 2">
                  <b>Hoàn thành</b>
                </b-badge>
              </template>
              <!-- <template v-slot:cell(tienDo)="data">
                <b-badge variant="danger" v-if="data.value == 1">
                    <b>Quá hạn</b>
                </b-badge>
                <b-badge variant="danger" v-else-if="data.value == 2">
                    <b>Trễ hạn</b>
                </b-badge>
                  <b-badge variant="success" v-else-if="data.value == 3">
                    <b>Đúng hạn</b>
                </b-badge>
                <b-badge variant="danger" v-else-if="data.value == 0">
                </b-badge>
              </template> -->
              <template v-slot:cell(actionStatus)="data">
                <span v-if="data.item.status==0">
                 <b-link
                  class="text-primary mr-2"
                  href="#"
                  @click.prevent="changeStatus(data, 1)"
                >
                  <i class="fas fa-play-circle"></i>
                 </b-link>
                </span>
                <span v-if="data.item.status<2">
                <b-link
                  class="text-primary mr-2"
                  href="#"
                  @click.prevent="changeStatus(data, 2)"
                >
                  <i class="fas fa-check-circle" style="color:green"></i>
                </b-link>
                </span>
               </template>
              <template v-slot:cell(action)="data">
                <b-link
                  class="text-primary mr-2"
                  href="#"
                  @click.prevent="viewItem(data)"
                >
                  <i class="fas fa-pencil-alt"></i>
                </b-link>

                <!-- Cong viec duoc giao khong co quyen xoa -->
                <!-- <b-link
                  class="text-danger"
                  href="#"
                  @click.prevent="deleteItem(data)"
                >
                  <i class="fas fa-trash"></i>
                </b-link> -->
              </template>
            </b-table>
            <b-badge v-if="totalRow != 0" variant="light">Tổng số công việc: {{ totalRow }}</b-badge>
          </b-row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import TaskSideBar from "../components/Task/TaskSideBar";
export default {
  name: "Tasks",
  components: {
    TaskSideBar,
  },
  data() {
    return {
      fields: [
        {
          key: "STT",
          label: "STT",
          thClass: "align-middle",
          thStyle: {width: "15px", textAlign : "center"},
        },
        {
          key: "name",
          label: "Tên công việc",
          sortable: true,
          thClass: "align-middle",
          thStyle: {width: "700px !important", textAlign : "center"},
        },
        {
          key: "empCreated",
          label: "Người giao",
          sortable: true,
          thClass: "align-middle",
          thStyle: {width: "250px !important", textAlign : "center"},
        },
        // {
        //   key: "employee",
        //   label: "Người nhận",
        //   sortable: true,
        //   thClass: "align-middle",
        //   thStyle: {width: "250px !important", textAlign : "center"},
        // },
        {
          key: "start",
          label: "Thời gian bắt đầu",
          sortable: true,
          tdClass: "text-center",
          thClass: "align-middle",
          thStyle: {width: "180px !important", textAlign : "center"},
        },
        {
          key: "end",
          label: "Thời gian kết thúc",
          sortable: true,
          tdClass: "text-center",
          thClass: "align-middle",
          thStyle: {width: "180px !important", textAlign : "center"},
        },
        // {
        //   key: "important",
        //   label: "Quan trọng",
        //   sortable: true,
        //   tdClass: "text-center",
        //   thClass: "align-middle",
        //   thStyle: { width: "120px !important", textAlign : "center" },
        // },
         {
          key: "label",
          label: "Hàng tháng",
          sortable: true,
          tdClass: "text-center",
          thClass: "align-middle",
          thStyle: { width: "120px !important", textAlign : "center" },
        },
        {
          key: "status",
          label: "Tình trạng",
          sortable: true,
          thClass: "align-middle",
          thStyle: { width: "120px !important", textAlign : "center" },
        },
        // {
        //   key: "tienDo",
        //   label: "Tiến độ",
        //   sortable: true,
        //   tdClass: "text-center",
        //   thClass: "align-middle",
        //   thStyle: { width: "120px !important", textAlign : "center" },
        // },
        {
          key: "actionStatus",
          label: "",
          tdClass: "text-center",
          thClass: "align-middle",
          thStyle: { width: "80px !important" , textAlign : "center"},
        },
        {
          key: "action",
          label: "",
          tdClass: "text-center",
          thClass: "align-middle",
          thStyle: { width: "80px !important" , textAlign : "center"},
        },
      ],
      items: [],
      currentPage: null,
      totalRow: null,
      perPage: null,
      sortBy: null,
      sortDesc: null,
      query: null,
      tabIndex: 0,
      item: null,

      //Tinh trang cua Task
      taskStatus: -1,
      taskStatuses: [
        // { value: 0, text: "Chưa bắt đầu" ,  html:  '<b-badge variant="Warning">Chưa thực hiện</b-badge>'},
        // { value: 1, text: "Đang thực hiện",  html: '<b-badge variant="info">Đang thực hiện</b-badge>'},
        // { value: 2, text: "Hoàn thành", html: '<b-badge variant="success">Hoàn thành</b-badge>' },
        { text: 'Chưa bắt đầu', value: 0, },
        { text: 'Đang thực hiện', value: 1},
        { text: 'Hoàn thành', value: 2 },
      ],
      scrollTop: 0,
      scrollHeight: 0,
      offsetTop: 0,
      offsetHeight: 0,
      headerSize: "1000000000000000px",
    };
  },

  beforeRouteEnter(to, from, next) {
    axios
      .get("/api/task/assignedby")
      .then((response) => {
        next((vm) => vm.initData(response.data));
        // next();
      })
      .catch((err) => {
        next();
      });
  },

   beforeRouteUpdate(to, from, next) {
    axios
      .get("/api/task/assignedby", { params: to.query })
      .then((response) => {
        this.items = response.data.items;
        this.totalRow = response.data.totalRow;
        // next();
      })
      .catch((err) => {
        next();
      });
  },
  computed: {
    task_create() {
      return this.$store.getters.hasPermission("task_create");
    },
    count() {
      return this.items.length;
    },
  },
  methods: {
    myCompare(itemA, itemB, key) {
      if (key !== "start") {
        // If field is not `date` we let b-table handle the sorting
        return false;
      } else {
        // Convert the string formatted date to a number that can be compared
        // Get the values being compared from the items
        let a = itemA[key];
        let b = itemB[key];
        // Split them into an array of parts (dd, mm, and yyyy)
        a = a.split("/");
        b = b.split("/");
        // convert string parts to numbers
        a =
          parseInt(a[2], 10) * 10000 +
          parseInt(a[1], 10) * 100 +
          parseInt(a[0]);
        b =
          parseInt(b[2], 10) * 10000 +
          parseInt(b[1], 10) * 100 +
          parseInt(b[0]);
        // Return the comparison result
        return a - b;
      }
    },
    initData(data) {
      this.items = data.items;
      this.totalRow = data.totalRow;
    },
    formatPrice(value) {
      let val = value / 1;
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    addItem() {
      this.$router.push(`/them_cong_viec`);
    },
    viewItem(data) {
      this.$router.push(`/cong_viec/${data.item.id}`);
    },
    deleteItem(data) {
      this.$toast.question("Bạn có thực sự muốn xóa không?", "Nhắc nhở", {
        timeout: 20000,
        close: false,
        overlay: true,
        displayMode: "once",
        position: "center",
        buttons: [
          [
            "<button><b>Có</b></button>",
            (instance, toast) => {
              axios
                .delete(`/api/task/${data.item.id}`)
                .then((res) => {
                  this.items.splice(data.index, 1);
                  this.totalRow = this.count--;
                  this.$toast.success("Xóa thành công !", "Thành công", {
                    timeout: 3000,
                  });
                })
                .catch((err) => {
                  this.$toast.error(err.response.data, "Lỗi", {
                    timeout: 3000,
                  });
                });
              instance.hide({ transitionOut: "fadeOut" }, toast, "button");
            },
            true,
          ],
          [
            "<button>Không</button>",
            function(instance, toast) {
              instance.hide({ transitionOut: "fadeOut" }, toast, "button");
            },
          ],
        ],
      });
    },
    //Filter
    queryItem() {
      let query = Object.assign({}, this.$route.query);
      query.q = this.query;
      this.item = null;
      this.$router.push({ query: query });
    },
    //Filter Status of Task
    filterStatus() {
      let query = Object.assign({}, this.$route.query);
      query.status = this.taskStatus;
      // query.page = 1;
      // this.currentPage = 1;
      this.$router.push({ query: query });
    },

    sortChanged(ctx) {
      this.item = null;
      let query = Object.assign({}, this.$route.query);
      query.sortBy = ctx.sortBy;
      query.sortDesc = ctx.sortDesc;
      this.$router.push({ query: query });
    },

    formatDate(value) {
      if (!value) return "";
      return this.$moment(value).format("DD/MM/YYYY");
    },

     changeStatus(data, status) {
      const payload = {
        status: status,
        taskId: data.item.id,
      };
      axios
        .put("/api/taskcomment", payload)
        .then((res) => {
          this.$toast.success("Cập nhật thành công!", "Thành công", {
               timeout: 3000,
          });
          this.items[data.index].status = status;
        })
        .catch((err) => {
          this.$toast.error(err.response.data, "Lỗi", { timeout: 3000 });
        });
    },
  },
};
</script>
<style>
  .link {
    color:rgb(0, 0, 0);
    text-decoration: none;
    background-color: none;
  }
  .linkImportant {
    color:rgb(0, 0, 0);
    text-decoration: none;
    background-color:rgb(255, 255, 181)
  }
</style>
